import {
  Apple, Baby, Bike, BookOpen, Briefcase, Camera, Car, Coffee, CookingPot, CreditCard, Dumbbell, Flower2, Footprints, Fuel,
  Gamepad2, Gem, Gift, Glasses, GraduationCap, Headphones, HeartPulse, Hotel, House, Lamp, Laptop, Music, PawPrint, Pill, Plane,
  Refrigerator, Shirt, ShoppingBasket, Smartphone, Sofa, Sparkles, Tag, Ticket, ToyBrick, Tv, Utensils, WashingMachine, Watch, Wrench, Zap,
} from "lucide-react";
import { assetUrl } from "@/lib/site";

export const CATEGORY_ICONS = {
  smartphone: [Smartphone, "Mobiles"], laptop: [Laptop, "Laptops"], headphones: [Headphones, "Audio"], tv: [Tv, "TVs"], camera: [Camera, "Cameras"],
  watch: [Watch, "Watches"], gamepad: [Gamepad2, "Gaming"], zap: [Zap, "Electronics"], shirt: [Shirt, "Fashion"], footprints: [Footprints, "Footwear"],
  gem: [Gem, "Jewellery"], glasses: [Glasses, "Eyewear"], sparkles: [Sparkles, "Beauty"], "heart-pulse": [HeartPulse, "Health"], pill: [Pill, "Pharmacy"],
  dumbbell: [Dumbbell, "Fitness"], bike: [Bike, "Sports & bikes"], baby: [Baby, "Baby & kids"], toy: [ToyBrick, "Toys"], sofa: [Sofa, "Furniture"],
  lamp: [Lamp, "Home decor"], house: [House, "Home"], "cooking-pot": [CookingPot, "Kitchen"], fridge: [Refrigerator, "Appliances"], washer: [WashingMachine, "Large appliances"],
  basket: [ShoppingBasket, "Grocery"], apple: [Apple, "Fresh food"], coffee: [Coffee, "Beverages"], utensils: [Utensils, "Food delivery"], plane: [Plane, "Flights"],
  hotel: [Hotel, "Hotels"], car: [Car, "Cars & rides"], fuel: [Fuel, "Fuel"], book: [BookOpen, "Books"], education: [GraduationCap, "Education"],
  pet: [PawPrint, "Pets"], flower: [Flower2, "Gifts & flowers"], wrench: [Wrench, "Tools"], briefcase: [Briefcase, "Office"], gift: [Gift, "Gifts"],
  card: [CreditCard, "Banking & cards"], ticket: [Ticket, "Movies & events"], music: [Music, "Music"], tag: [Tag, "Other"],
};

const isImage = (v) => /^(https:\/\/|\/api\/files\/)/.test(v || "");

// Category icon: a picked icon name, an uploaded/pasted image, or the first letter as a fallback.
export const CategoryIcon = ({ icon, name = "", className = "h-7 w-7", size = 16 }) => {
  if (isImage(icon)) return <img src={assetUrl(icon)} alt="" loading="lazy" className={`${className} rounded-md object-contain bg-white border border-slate-100 shrink-0`} />;
  const Icon = CATEGORY_ICONS[icon]?.[0];
  return (
    <span className={`${className} rounded-md bg-emerald-50 text-emerald-700 grid place-items-center text-xs font-bold shrink-0`}>
      {Icon ? <Icon size={size} /> : name.slice(0, 1)}
    </span>
  );
};
